// helper function which creates the action function

import startCase from 'lodash.startcase'
import makeCreate from './makeCreate'
import makeGet from './makeGet'
import makeDownload from './makeDownload'
import makeTrigger from './makeTrigger'
import makeUpdate from './makeUpdate'

export default ({ actionType, name, config, common }) => {
  let specificFn
  switch (actionType) {
    case common.actionTypes.create:
      specificFn = makeCreate({ actionType, name, config, common })
      break
    case common.actionTypes.get:
      specificFn = makeGet({ actionType, name, config, common })
      break
    case common.actionTypes.download:
      specificFn = makeDownload({ actionType, name, config, common })
      break
    case common.actionTypes.trigger:
      specificFn = makeTrigger({ actionType, name, config, common })
      break
    case common.actionTypes.update:
      specificFn = makeUpdate({ actionType, name, config, common })
      break
    default:
      break
  }
  let actionFn = async (context, params) => {
    let noActionWhileLoading = [common.actionTypes.download, common.actionTypes.trigger]
    if (noActionWhileLoading.includes(actionType) && !!context.state.loadingIndicators[name]) {
      context.dispatch('warning', `${startCase(name)}: Attempted to perform ${actionType} while current one in progress. Aborting`)
      return false
    }
    context.commit('setLoadingIndicator', { indicator: name, loading: context.state.loadingIndicators[name] + 1 })
    // error handling happens in specificFn
    // as res, we get true or false depending on if everything went ok
    let ok = await specificFn(context, params)
    context.commit('setLoadingIndicator', { indicator: name, loading: Math.max(0, context.state.loadingIndicators[name] - 1) })
    return ok
  }
  return actionFn
}
